import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { toast } from 'react-toastify';

import InputWrapper from '../../../common/InputWrapper';
import Button from '../../../common/Button';
import UploadFiles from '../../../common/UploadFiles';

import { fetchAddFbmPdfSticker, fetchAddFbmTextSticker } from '../../../../actions/packing';

import { parseError } from '../../../../helpers';

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  margin-top: 8px;
  color: #7e57c2;
  cursor: pointer;

  input {
    max-width: 200px;
    margin-right: 10px;
  }

  .file-upload {
    display: flex;
    flex-direction: column;
    width: 100%;

    button {
      width: max-content;
    }
  }

  .sticker {
    color: #72747b;
    cursor: auto;
    a,
    i {
      cursor: pointer;
    }
    a,
    span,
    i {
      color: #7e57c2;
    }

    i {
      margin-left: 8px;
    }
  }
  .sticker-disabled {
    color: #72747b;
    cursor: auto;
    a {
      cursor: pointer;
    }
    a,
    span,
    i {
      color: #72747b;
    }
  }
`;

const PackingMarketplaceBarcode = (props) => {
  const { currentOrder, type, requirements, actualizeOrder, data } = props;

  const { shipmentType, pallets, status } = currentOrder;

  const dispatch = useDispatch();

  const [textIsOpen, setTextIsOpen] = useState(false);
  const [textValue, setTextValue] = useState('');

  const [pdfIsOpen, setPdfIsOpen] = useState(false);
  const [pdfFile, setPdfFile] = useState('');

  const [loading, setLoading] = useState(false);

  const stickerType = useSelector(
    (state) => state.orders.worksheetFormTemplate[`${type}_sticker_type`],
  );

  if (
    status !== 'ORDER_INFO_PACKED_DOCUMENTS_REQUIRED' &&
    (stickerType === 'PDF' ? !data?.files?.[0]?.url : !data.fbmStickerBarcode)
  ) {
    return null;
  }

  const orderId = currentOrder?.id;

  const handleSavePdf = async () => {
    const formData = new FormData();
    const values = {
      print_when_packing: true,
      copies_qty: 1,
      upfile: pdfFile,
    };
    Object.entries(values).forEach(([key, value]) => formData.append(key, value));
    formData.append('id', orderId);
    formData.append('barcode', data.barcode);

    setLoading(true);

    await dispatch(fetchAddFbmPdfSticker(formData, type))
      .then(async () => {
        await actualizeOrder(orderId);
        toast.info('Pdf-стикер успешно добавлен');
      })
      .catch((err) => {
        toast.error(parseError(err));
      });
    setLoading(false);
    setPdfIsOpen(false);
  };

  const handleSaveText = async () => {
    setLoading(true);

    const dispatchObj = {
      sticker_barcode: textValue,
      id: orderId,
    };

    dispatchObj[`${type}_barcode`] = data.barcode;

    await dispatch(fetchAddFbmTextSticker(dispatchObj, type))
      .then(async () => {
        await actualizeOrder(orderId);
        toast.info('Штрихкод успешно добавлен');
      })
      .catch((err) => {
        toast.error(parseError(err));
      });

    setLoading(false);
    setTextIsOpen(false);
  };

  const handleOpen = () => {
    if (stickerType === 'TEXT') {
      setTextIsOpen(true);
    }

    if (stickerType === 'PDF') {
      setPdfIsOpen(true);
    }
  };

  return (
    <Wrapper>
      {stickerType === 'PDF' ? (
        <>
          {pdfIsOpen ? (
            <>
              <div className="file-upload">
                <div className="row mt-1">
                  <div className="col-12">
                    <div className="form-group">
                      <UploadFiles
                        files={pdfFile ? [pdfFile] : []}
                        setFiles={(data) => setPdfFile(data[0])}
                        isSingle
                        accept={['.pdf']}
                      />
                    </div>
                  </div>
                </div>
                <Button
                  text="Сохранить"
                  disabled={!pdfFile}
                  loading={loading}
                  onClick={handleSavePdf}
                  icon="fe-check"
                />
              </div>
            </>
          ) : (
            <>
              {!data?.files?.[0]?.url ? (
                <>
                  {status === 'ORDER_INFO_PACKED_DOCUMENTS_REQUIRED' || stickerType === 'PDF' ? (
                    <div className="d-flex align-items-center" onClick={handleOpen}>
                      <i className="fe-plus" />
                      <div className="ml-1">Прикрепить стикер в pdf</div>
                    </div>
                  ) : null}
                </>
              ) : (
                <>
                  {status === 'ORDER_INFO_PACKED_DOCUMENTS_REQUIRED' ? (
                    <div className="sticker">
                      <font className="pr-1"> Доп. маркировка:</font>
                      <a href={data.files[0].url} target="_blank">
                        Pdf-стикер
                      </a>
                      <i className="fe-edit" onClick={handleOpen}></i>
                    </div>
                  ) : (
                    <div className="sticker-disabled">
                      <font className="pr-1"> Доп. маркировка:</font>
                      <a href={data.files[0].url} target="_blank">
                        Pdf-стикер
                      </a>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </>
      ) : null}

      {stickerType === 'TEXT' ? (
        <>
          {!textIsOpen ? (
            <>
              {!data.fbmStickerBarcode ? (
                <>
                  {status === 'ORDER_INFO_PACKED_DOCUMENTS_REQUIRED' || stickerType === 'TEXT' ? (
                    <div className="d-flex align-items-center" onClick={handleOpen}>
                      <i className="fe-plus" />
                      <div>Указать штрихкод</div>
                    </div>
                  ) : null}
                </>
              ) : (
                <>
                  {status === 'ORDER_INFO_PACKED_DOCUMENTS_REQUIRED' ? (
                    <div className="sticker">
                      Доп. маркировка: <span>{data.fbmStickerBarcode}</span>
                      <i className="fe-edit" onClick={handleOpen}></i>
                    </div>
                  ) : (
                    <div className="sticker-disabled">
                      Доп. маркировка: <span>{data.fbmStickerBarcode}</span>
                    </div>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <InputWrapper
                value={textValue}
                disabled={loading}
                onChange={(e) => setTextValue(e.target.value)}
              />
              <Button
                text="Сохранить"
                disabled={textValue === ''}
                loading={loading}
                onClick={handleSaveText}
                icon="fe-check"
              />
            </>
          )}
        </>
      ) : null}
    </Wrapper>
  );
};

export default PackingMarketplaceBarcode;
